import { IMerchantIdentifier } from './merchant-identifier.interface';

export interface IThreeDSecureProviderContractCreate {
  name: string;
  mcc?: string;
  startDate?: Date;
  endDate?: Date;
  merchantId: string;
  processorId: string;
  transactionPwd: string;
  apiIdentifier: string;
  apiKey: string;
  orgUnitId: string;
  threeDSecureVersion?: string;
  merchantIdentifiers?: IMerchantIdentifier[];
  onboardingVia?: string;
}
